// extracted by mini-css-extract-plugin
export default {"confirm":"ConfirmationModalV2_confirm__EUWue","confirm_input":"ConfirmationModalV2_confirm_input__wsVLS","button_container":"ConfirmationModalV2_button_container__yn+pn"};